(async function () {
  const root = document.querySelector(".gs-partner-map");
  if (!root) return;

  const partnersUrl = root.getAttribute("data-partners-url");
  const statusEl = document.getElementById("gs-pm-status");
  const listEl = document.getElementById("gs-pm-list");
  const mapEl = document.getElementById("gs-pm-map");

  const queryEl = document.getElementById("gs-pm-query");
  const radiusEl = document.getElementById("gs-pm-radius");
  const hufschuhEl = document.getElementById("gs-pm-hufschuh");
  const klebeEl = document.getElementById("gs-pm-klebebeschlag");
  const searchBtn = document.getElementById("gs-pm-search");

  // Geo UI (optional)
  const geoBtn = document.getElementById("gs-pm-geo-btn");
  const geoHintEl = document.getElementById("gs-pm-geo-hint");

  const GOOGLE_KEY = (window.GS_PARTNER_MAP && window.GS_PARTNER_MAP.GOOGLE_GEOCODING_KEY) || "";
  const INTERNAL_FALLBACK_EMAIL = "info@good-smith.com";

  // Custom marker icon (Shopify CDN)
  // NOTE: PNG is 100x100, but we FORCE a sane Leaflet size to avoid distortion.
  const MARKER_ICON_URL =
    "https://cdn.shopify.com/s/files/1/0014/1036/7600/files/Goodsmith_Icon_schwarz_Zeichenflaeche_1.png?v=1773915839";

  // ===== Geolocation state =====
  let hasAskedForGeo = false;
  let geoCenterOverride = null;
  let geoActive = false;

  // Auto-search after geo
  let geoAutoSearchEnabled = true;
  let geoAutoSearchInFlight = false;

  function setStatus(msg) {
    if (statusEl) statusEl.textContent = msg || "";
  }

  function setGeoHint(msg) {
    if (geoHintEl) geoHintEl.textContent = msg || "";
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  function escapeHtml(s) {
    return String(s || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function buildMailtoFallback(payload) {
    const subject = `Partner-Feedback: ${payload.partner_name} (${payload.partner_zip} ${payload.partner_city})`;
    const body = [
      `Grund: ${payload.reason}`,
      payload.message ? `Kommentar: ${payload.message}` : `Kommentar:`,
      payload.reporter_email
        ? `Meldende E-Mail: ${payload.reporter_email}`
        : `Meldende E-Mail: (nicht angegeben)`,
      ``,
      `--- Partner ---`,
      `Partner-ID: ${payload.partner_id}`,
      `Name: ${payload.partner_name}`,
      `Ort: ${payload.partner_zip} ${payload.partner_city} (${payload.partner_country})`,
      `Distanz (km): ${payload.distance_km}`,
      `Services: Hufschuh=${payload.services_hufschuh}, Klebebeschlag=${payload.services_klebebeschlag}`,
      ``,
      `--- Suche ---`,
      `Suchort: ${payload.search_location}`,
      `Suchort (formatted): ${payload.search_formatted}`,
      `Radius: ${payload.search_radius_km}`,
      `Filter: Hufschuh=${payload.search_filter_hufschuh}, Klebebeschlag=${payload.search_filter_klebebeschlag}`,
      `Zeitpunkt: ${payload.timestamp}`,
    ].join("\n");

    return `mailto:${INTERNAL_FALLBACK_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  function sendFeedback(payload) {
    if (payload.reporter_email && window._learnq && Array.isArray(window._learnq)) {
      window._learnq.push(["identify", { $email: payload.reporter_email }]);
    }

    if (window._learnq && Array.isArray(window._learnq)) {
      window._learnq.push(["track", "partner_feedback_submitted", payload]);
      return { ok: true, via: "klaviyo" };
    }

    window.location.href = buildMailtoFallback(payload);
    return { ok: false, via: "mailto" };
  }

  async function loadPartners() {
    setStatus("Lade Partnerdaten …");
    const res = await fetch(partnersUrl, { cache: "no-store" });
    if (!res.ok) throw new Error(`partners.json nicht erreichbar (${res.status})`);
    const data = await res.json();
    if (!data || !Array.isArray(data.partners)) throw new Error("Ungültiges partners.json Format");
    setStatus(``);
    return data.partners;
  }

  async function geocodeSearch(q) {
    if (!GOOGLE_KEY || GOOGLE_KEY === "__SET_IN_CUSTOMIZER__") {
      throw new Error("Google Geocoding Key fehlt (Section Setting).");
    }
    const url = new URL("https://maps.googleapis.com/maps/api/geocode/json");
    url.searchParams.set("address", q);
    url.searchParams.set("key", GOOGLE_KEY);
    const res = await fetch(url.toString());
    const data = await res.json();
    if (data.status !== "OK" || !data.results?.length) {
      throw new Error(`Adresse nicht gefunden (${data.status}).`);
    }
    const loc = data.results[0].geometry.location;
    return { lat: loc.lat, lng: loc.lng, formatted: data.results[0].formatted_address };
  }

  // Wenn User tippt -> Geo deaktivieren
  function clearGeoOnManualInput() {
    if (!queryEl) return;
    const v = (queryEl.value || "").trim();
    if (v.length > 0 && geoActive) {
      geoActive = false;
      geoCenterOverride = null;
      setGeoHint("");
    }
    geoAutoSearchInFlight = false;
  }

  // -----------------------------
  // Helpers for UI fields
  // -----------------------------
  function normalizePhoneForWa(phone) {
    const digits = String(phone || "").replace(/[^\d]/g, "");
    if (!digits) return "";
    if (digits.startsWith("00")) return digits.slice(2);
    return digits;
  }

  function preferredList(p) {
    return Array.isArray(p.contact?.preferred) ? p.contact.preferred : [];
  }

  function hasWhatsappPreferred(p) {
    return preferredList(p).some((x) => String(x || "").trim().toLowerCase() === "whatsapp");
  }

  function buildWhatsappLink(p) {
    const phone = p.contact?.phone;
    if (!phone) return "";
    if (!hasWhatsappPreferred(p)) return "";

    const waPhone = normalizePhoneForWa(phone);
    if (!waPhone) return "";

    const msg = `Hallo ${
      p.display_name || "Goodsmith Partner"
    }, ich habe Ihre Kontaktdaten über die Goodsmith-Partnerkarte gefunden und würde gern einen Termin anfragen.`;
    return `https://wa.me/${encodeURIComponent(waPhone)}?text=${encodeURIComponent(msg)}`;
  }

  function normalizeUrl(u) {
    const s = String(u || "").trim();
    if (!s) return "";
    if (s.startsWith("http://") || s.startsWith("https://")) return s;
    return `https://${s}`;
  }

  function formatServicesLine(p) {
    const s1 = p.services?.hufschuh ? "Hufschuh" : "";
    const s2 = p.services?.klebebeschlag ? "Klebebeschlag" : "";
    if (s1 && s2) return `${s1}, ${s2}`;
    return s1 || s2 || "";
  }

  // -----------------------------
  // OPTION 1 – UI-Kommunikation:
  // - Hufschuh ist "bestätigt" (true)
  // - false/leer = "nicht bestätigt" (Partner evtl. bietet es trotzdem an, hat aber nicht aktualisiert)
  // -----------------------------
  function setupHufschuhFilterCopy() {
    // Filter-Hinweistext anpassen (falls vorhanden)
    const hint = root.querySelector(".gs-pm-filter-hint");
    if (hint) {
      hint.textContent =
        "Nur Partner anzeigen, die die Services bestätigt haben. Hinweis: „Hufschuh“ ist neu – manche Partner haben ihre Angaben noch nicht aktualisiert.";
    }

    // Checkbox-Label auf "Hufschuh (bestätigt)" setzen (robust)
    const label = root.querySelector('label[for="gs-pm-hufschuh"]');
    if (label) {
      // Falls Label komplex ist, nur Text ersetzen wenn es exakt passt
      const txt = (label.textContent || "").trim();
      if (txt.toLowerCase() === "hufschuh") {
        label.textContent = "Hufschuh (bestätigt)";
      } else {
        // Wenn z.B. ein <span> drin ist: versuch Span zu finden
        const span = label.querySelector("span");
        if (span && (span.textContent || "").trim().toLowerCase() === "hufschuh") {
          span.textContent = "Hufschuh (bestätigt)";
        }
      }
    }
  }

  // -----------------------------
  // Badge (label + tooltip) – from partners.json badge:{label, tooltip}
  // Custom tooltip via data-tooltip (works on mobile with tap)
  // -----------------------------
  function renderBadgeInline(p) {
    const label = p.badge?.label;
    if (!label) return "";

    const tip = (p.badge?.tooltip || "").trim();
    const tipAttr = tip ? ` data-tooltip="${escapeHtml(tip)}"` : "";
    const aria = tip ? ` aria-label="${escapeHtml(tip)}"` : ` aria-label="${escapeHtml(label)}"`;

    return `
      <span class="gs-pm-badge" role="button" tabindex="0"${aria}${tipAttr}>
        ${escapeHtml(label)}
      </span>
    `;
  }

  function renderFieldsHtml(p) {
    const phone = p.contact?.phone
      ? `
        <div class="gs-pm-field">
          <div class="gs-pm-field-label">Telefon</div>
          <div class="gs-pm-field-value"><a href="tel:${escapeHtml(p.contact.phone)}">${escapeHtml(
          p.contact.phone
        )}</a></div>
        </div>`
      : "";

    const email = p.contact?.email
      ? (() => {
          const subject = "Anfrage über die Goodsmith-Partnerkarte";
          const body =
            `Hallo ${p.display_name || "Goodsmith Partner"},\n\n` +
            `ich habe Ihre Kontaktdaten über die Goodsmith-Partnerkarte gefunden und würde gern eine Anfrage stellen.\n\n` +
            `Viele Grüße`;

          const mailto =
            `mailto:${escapeHtml(p.contact.email)}` +
            `?subject=${encodeURIComponent(subject)}` +
            `&body=${encodeURIComponent(body)}`;

          return `
            <div class="gs-pm-field">
              <div class="gs-pm-field-label">E-Mail</div>
              <div class="gs-pm-field-value">
                <a href="${mailto}">${escapeHtml(p.contact.email)}</a>
              </div>
            </div>`;
        })()
      : "";

    const websiteUrl = p.contact?.website ? normalizeUrl(p.contact.website) : "";
    const website = websiteUrl
      ? `
        <div class="gs-pm-field">
          <div class="gs-pm-field-label">Web</div>
          <div class="gs-pm-field-value"><a href="${escapeHtml(
            websiteUrl
          )}" target="_blank" rel="noopener">Website öffnen</a></div>
        </div>`
      : "";

    const waUrl = buildWhatsappLink(p);
    const whatsapp = waUrl
      ? `
        <div class="gs-pm-field">
          <div class="gs-pm-field-label">WhatsApp</div>
          <div class="gs-pm-field-value"><a href="${escapeHtml(
            waUrl
          )}" target="_blank" rel="noopener">Nachricht schreiben</a></div>
        </div>`
      : "";

    return `<div class="gs-pm-fields">${phone}${email}${website}${whatsapp}</div>`;
  }

  // ✅ geändert (Option 1)
  function renderMetaHtml(p) {
    const preferred = preferredList(p)
      .map((x) => String(x || "").trim())
      .filter(Boolean)
      .join(", ");

    const servicesConfirmed = formatServicesLine(p);

    const pref = preferred
      ? `<div class="gs-pm-meta-line"><div class="gs-pm-meta-k">Bevorzugt</div><div class="gs-pm-meta-v">${escapeHtml(
          preferred
        )}</div></div>`
      : "";

    const svc = servicesConfirmed
      ? `<div class="gs-pm-meta-line"><div class="gs-pm-meta-k">Service</div><div class="gs-pm-meta-v">${escapeHtml(
          servicesConfirmed
        )}</div></div>`
      : "";

    // Option 1: false/leer = nicht bestätigt (nicht "bietet es nicht an")
    const hufschuhConfirmed = !!p.services?.hufschuh;
    const hufschuhStatus = !hufschuhConfirmed
      ? `<div class="gs-pm-meta-line"><div class="gs-pm-meta-k">Hufschuh</div><div class="gs-pm-meta-v">nicht bestätigt</div></div>`
      : "";

    if (!pref && !svc && !hufschuhStatus) return "";
    return `<div class="gs-pm-meta-block">${pref}${svc}${hufschuhStatus}</div>`;
  }

  function renderFooterHtml(p) {
    const distance = typeof p.distance_km === "number" ? Math.round(p.distance_km) : null;

    return `
      <div class="gs-pm-item-footer">
        ${distance !== null ? `<div class="gs-pm-distance">Entfernung: ${distance} km</div>` : ``}

        <button
          type="button"
          class="gs-pm-feedback-btn"
          data-partner-id="${escapeHtml(p.partner_id)}">
          Problem melden
        </button>
      </div>
    `;
  }

  // -----------------------------
  // Map init
  // -----------------------------
  if (!mapEl) {
    setStatus("Map-Container (#gs-pm-map) nicht gefunden.");
    return;
  }

  const map = L.map(mapEl, { scrollWheelZoom: false }).setView([51.0, 10.0], 6);
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 18,
    attribution: "&copy; OpenStreetMap contributors",
  }).addTo(map);

  // ============================
  // Recommended clustering setup
  // ============================
  const cluster = L.markerClusterGroup({
    maxClusterRadius: 22,
    spiderfyOnMaxZoom: true,
    spiderfyDistanceMultiplier: 1.6,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: true,
    chunkedLoading: true,
    //disableClusteringAtZoom: 10,
  });
  map.addLayer(cluster);

  // Marker icon: small + square (prevents distortion of 100x100 png)
  const partnerIcon = L.icon({
    iconUrl: MARKER_ICON_URL,
    iconSize: [36, 36],
    iconAnchor: [18, 36],
    popupAnchor: [0, -32],
  });

  function setupMobileTabs() {
    const tabsWrap = root.querySelector(".gs-pm-mobile-tabs");
    if (!tabsWrap) return;

    root.classList.add("is-view-list");

    const tabs = Array.from(tabsWrap.querySelectorAll(".gs-pm-tab"));
    function setActive(view) {
      if (view === "map") {
        root.classList.remove("is-view-list");
        root.classList.add("is-view-map");
        setTimeout(() => map.invalidateSize(true), 50);
      } else {
        root.classList.remove("is-view-map");
        root.classList.add("is-view-list");
      }

      tabs.forEach((b) => b.classList.toggle("is-active", b.getAttribute("data-gs-view") === view));
    }

    tabsWrap.addEventListener("click", (e) => {
      const btn = e.target && e.target.closest ? e.target.closest(".gs-pm-tab") : null;
      if (!btn) return;
      setActive(btn.getAttribute("data-gs-view") || "list");
    });

    window.__GS_PM_SET_VIEW__ = setActive;
  }

  setupMobileTabs();

  // ✅ neu: Copy für Hufschuh-Filter (Option 1)
  setupHufschuhFilterCopy();

  let lastSearchContext = {
    query: "",
    radiusKm: null,
    needHufschuh: false,
    needKlebe: false,
    formatted: "",
  };
  let activePartnerForFeedback = null;

  function ensureFeedbackModal() {
    if (document.getElementById("gs-pm-feedback-modal")) return;

    const wrap = document.createElement("div");
    wrap.id = "gs-pm-feedback-modal";
    wrap.innerHTML = `
      <div class="gs-pm-fb-backdrop" data-close="1"></div>
      <div class="gs-pm-fb-panel" role="dialog" aria-modal="true" aria-labelledby="gs-pm-fb-title">
        <div class="gs-pm-fb-head">
          <div>
            <div id="gs-pm-fb-title" class="gs-pm-fb-title">Problem melden</div>
            <div id="gs-pm-fb-sub" class="gs-pm-fb-sub"></div>
          </div>
          <button class="gs-pm-fb-x" type="button" data-close="1">×</button>
        </div>

        <div class="gs-pm-fb-body">
          <label class="gs-pm-fb-label">
            Grund (Pflicht)
            <select id="gs-pm-fb-reason" class="gs-pm-fb-input">
              <option value="">Bitte auswählen</option>
              <option value="Nicht erreichbar">Nicht erreichbar</option>
              <option value="Arbeitet nicht mehr mit Goodsmith">Arbeitet nicht mehr mit Goodsmith</option>
              <option value="Falsche Kontaktdaten">Falsche Kontaktdaten</option>
              <option value="Falscher Standort">Falscher Standort</option>
              <option value="Sonstiges">Sonstiges</option>
            </select>
          </label>

          <label class="gs-pm-fb-label">
            Kommentar (optional)
            <textarea id="gs-pm-fb-message" class="gs-pm-fb-input" rows="4" placeholder="Was ist passiert? (optional)"></textarea>
          </label>

          <label class="gs-pm-fb-label">
            Deine E-Mail (optional)
            <input id="gs-pm-fb-email" class="gs-pm-fb-input" type="email" placeholder="nur falls wir Rückfragen haben" />
          </label>

          <div id="gs-pm-fb-status" class="gs-pm-fb-status"></div>

          <div class="gs-pm-fb-actions">
            <button id="gs-pm-fb-cancel" type="button" class="gs-pm-fb-btn gs-pm-fb-btn-secondary" data-close="1">Abbrechen</button>
            <button id="gs-pm-fb-submit" type="button" class="gs-pm-fb-btn">Absenden</button>
          </div>
        </div>
      </div>
    `;

    const style = document.createElement("style");
    style.textContent = `
      #gs-pm-feedback-modal { display:none; position:fixed; inset:0; z-index:9999; }
      #gs-pm-feedback-modal.is-open { display:block; }
      .gs-pm-fb-backdrop { position:absolute; inset:0; background:rgba(0,0,0,.45); }
      .gs-pm-fb-panel { position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); width:min(560px, calc(100vw - 24px)); background:#fff; border-radius:12px; box-shadow:0 10px 30px rgba(0,0,0,.25); }
      .gs-pm-fb-head { display:flex; justify-content:space-between; gap:12px; padding:14px 16px; border-bottom:1px solid #eee; }
      .gs-pm-fb-title { font-weight:700; }
      .gs-pm-fb-sub { font-size:13px; color:#444; margin-top:2px; }
      .gs-pm-fb-x { border:0; background:transparent; font-size:24px; line-height:1; cursor:pointer; padding:0 6px; }
      .gs-pm-fb-body { padding:14px 16px 16px; }
      .gs-pm-fb-label { display:flex; flex-direction:column; gap:6px; font-size:13px; margin-bottom:12px; }
      .gs-pm-fb-input { width:100%; border:1px solid #ddd; border-radius:8px; padding:10px; font-size:14px; }
      .gs-pm-fb-status { min-height:18px; font-size:13px; color:#444; margin:6px 0 12px; }
      .gs-pm-fb-actions { display:flex; justify-content:flex-end; gap:10px; }
      .gs-pm-fb-btn { border:1px solid #111; background:#111; color:#fff; padding:10px 12px; border-radius:8px; cursor:pointer; }
      .gs-pm-fb-btn-secondary { background:#fff; color:#111; border-color:#ccc; }
    `;
    document.head.appendChild(style);
    document.body.appendChild(wrap);

    wrap.addEventListener("click", (e) => {
      const t = e.target;
      if (t && t.getAttribute && t.getAttribute("data-close") === "1") closeFeedbackModal();
    });

    document.getElementById("gs-pm-fb-submit").addEventListener("click", submitFeedback);
    document.addEventListener("keydown", (e) => {
      const modal = document.getElementById("gs-pm-feedback-modal");
      if (e.key === "Escape" && modal && modal.classList.contains("is-open")) closeFeedbackModal();
    });
  }

  function openFeedbackModal(partner) {
    ensureFeedbackModal();
    activePartnerForFeedback = partner;

    const modal = document.getElementById("gs-pm-feedback-modal");
    const sub = document.getElementById("gs-pm-fb-sub");
    const status = document.getElementById("gs-pm-fb-status");

    document.getElementById("gs-pm-fb-reason").value = "";
    document.getElementById("gs-pm-fb-message").value = "";
    document.getElementById("gs-pm-fb-email").value = "";
    status.textContent = "";

    sub.textContent = `${partner.display_name || "Partner"} – ${partner.zip} ${partner.city} (${partner.country})`;

    modal.classList.add("is-open");
  }

  function closeFeedbackModal() {
    const modal = document.getElementById("gs-pm-feedback-modal");
    if (modal) modal.classList.remove("is-open");
    activePartnerForFeedback = null;
  }

  function submitFeedback() {
    const status = document.getElementById("gs-pm-fb-status");
    const reason = document.getElementById("gs-pm-fb-reason").value;
    const message = document.getElementById("gs-pm-fb-message").value.trim();
    const reporterEmail = document.getElementById("gs-pm-fb-email").value.trim();

    if (!activePartnerForFeedback) {
      status.textContent = "Kein Partner ausgewählt.";
      return;
    }
    if (!reason) {
      status.textContent = "Bitte einen Grund auswählen.";
      return;
    }

    const p = activePartnerForFeedback;
    const payload = {
      partner_id: p.partner_id,
      partner_name: p.display_name,
      partner_zip: p.zip,
      partner_city: p.city,
      partner_country: p.country,
      distance_km: typeof p.distance_km === "number" ? Math.round(p.distance_km) : null,
      services_hufschuh: !!p.services?.hufschuh,
      services_klebebeschlag: !!p.services?.klebebeschlag,
      reason,
      message: message || null,
      reporter_email: reporterEmail || null,
      search_location: lastSearchContext.query || null,
      search_formatted: lastSearchContext.formatted || null,
      search_radius_km: lastSearchContext.radiusKm,
      search_filter_hufschuh: !!lastSearchContext.needHufschuh,
      search_filter_klebebeschlag: !!lastSearchContext.needKlebe,
      timestamp: new Date().toISOString(),
    };

    status.textContent = "Sende …";
    const res = sendFeedback(payload);

    if (res.ok) {
      status.textContent = "Danke. Dein Feedback wurde übermittelt.";
      setTimeout(() => closeFeedbackModal(), 900);
    } else {
      status.textContent = "Öffne E-Mail …";
      setTimeout(() => closeFeedbackModal(), 500);
    }
  }

  function clearList() {
    if (listEl) listEl.innerHTML = "";
  }

  function addListItem(item, onSelectPartner) {
    const ausb = (item.ausbildung || "").toString().trim();

    const div = document.createElement("div");
    div.className = "gs-pm-item";
    div.innerHTML = `
      <div class="gs-pm-title-row">
        <div class="gs-pm-title">${escapeHtml(item.display_name || "Partner")}</div>
        <div class="gs-pm-badge-wrap">${renderBadgeInline(item)}</div>
      </div>

      ${ausb ? `<div class="gs-pm-sub">${escapeHtml(ausb)}</div>` : ``}
      <div class="gs-pm-loc">${escapeHtml(item.zip)} ${escapeHtml(item.city)} (${escapeHtml(item.country)})</div>

      ${renderFieldsHtml(item)}

      <div class="gs-pm-sep"></div>

      ${renderMetaHtml(item)}

      ${renderFooterHtml(item)}
    `;

    div.addEventListener("click", (e) => {
      const isFeedbackBtn = e.target && e.target.closest ? e.target.closest(".gs-pm-feedback-btn") : null;
      if (isFeedbackBtn) return;

      const isLink = e.target && e.target.closest ? e.target.closest("a") : null;
      if (isLink) return;

      const isBadge = e.target && e.target.closest ? e.target.closest(".gs-pm-badge") : null;
      if (isBadge) return;

      onSelectPartner();
    });

    listEl.appendChild(div);
  }

  function buildPopup(p) {
    const ausb = (p.ausbildung || "").toString().trim();

    return `
      <div class="gs-pm-popup">
        <div class="gs-pm-title-row">
          <div class="gs-pm-title">${escapeHtml(p.display_name || "Partner")}</div>
          <div class="gs-pm-badge-wrap">${renderBadgeInline(p)}</div>
        </div>

        ${ausb ? `<div class="gs-pm-sub">${escapeHtml(ausb)}</div>` : ``}
        <div class="gs-pm-loc">${escapeHtml(p.zip)} ${escapeHtml(p.city)} (${escapeHtml(p.country)})</div>

        ${renderFieldsHtml(p)}

        <div class="gs-pm-sep"></div>

        ${renderMetaHtml(p)}

        ${renderFooterHtml(p)}
      </div>
    `;
  }

  // ---------- Feedback button ----------
  document.addEventListener("click", (e) => {
    const btn = e.target && e.target.closest ? e.target.closest(".gs-pm-feedback-btn") : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const pid = btn.getAttribute("data-partner-id");
    if (!pid) return;

    const found =
      (window.__GS_LAST_FILTERED__ || []).find((x) => x.partner_id === pid) ||
      (window.__GS_LAST_RENDERED__ || []).find((x) => x.partner_id === pid);

    if (found) openFeedbackModal(found);
  });

  // ---------- Badge tooltip behavior (mobile + stop map open) ----------
  function closeAllBadgeTips(exceptEl) {
    document.querySelectorAll(".gs-pm-badge.is-tip-open").forEach((el) => {
      if (exceptEl && el === exceptEl) return;
      el.classList.remove("is-tip-open");
    });
  }

  document.addEventListener(
    "click",
    (e) => {
      const badge = e.target && e.target.closest ? e.target.closest(".gs-pm-badge") : null;
      if (!badge) {
        closeAllBadgeTips(null);
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (!badge.getAttribute("data-tooltip")) return;

      const willOpen = !badge.classList.contains("is-tip-open");
      closeAllBadgeTips(badge);
      if (willOpen) badge.classList.add("is-tip-open");
      else badge.classList.remove("is-tip-open");
    },
    true
  );

  document.addEventListener(
    "keydown",
    (e) => {
      const badge = e.target && e.target.classList && e.target.classList.contains("gs-pm-badge") ? e.target : null;
      if (!badge) return;

      if (e.key === "Escape") {
        closeAllBadgeTips(null);
        return;
      }

      if (e.key !== "Enter" && e.key !== " ") return;

      e.preventDefault();
      e.stopPropagation();

      if (!badge.getAttribute("data-tooltip")) return;

      const willOpen = !badge.classList.contains("is-tip-open");
      closeAllBadgeTips(badge);
      if (willOpen) badge.classList.add("is-tip-open");
      else badge.classList.remove("is-tip-open");
    },
    true
  );

  // ---------- Load partners ----------
  let partners = [];
  try {
    partners = await loadPartners();
  } catch (e) {
    setStatus(String(e.message || e));
    return;
  }

  async function runSearch() {
    const q = (queryEl?.value || "").trim();

    const radiusKm = Number(radiusEl?.value || 100);
    const needHufschuh = !!hufschuhEl?.checked;
    const needKlebe = !!klebeEl?.checked;

    lastSearchContext.radiusKm = radiusKm;
    lastSearchContext.needHufschuh = needHufschuh;
    lastSearchContext.needKlebe = needKlebe;

    setStatus("Suche Standort …");

    let center;

    if (geoActive && geoCenterOverride && !q) {
      center = geoCenterOverride;
      lastSearchContext.query = "Aktueller Standort";
      lastSearchContext.formatted = geoCenterOverride.formatted || "Aktueller Standort";
    } else {
      if (!q) {
        setStatus("Bitte PLZ oder Adresse eingeben (oder Standort-Icon nutzen).");
        return;
      }
      geoActive = false;
      geoCenterOverride = null;
      setGeoHint("");

      lastSearchContext.query = q;

      try {
        center = await geocodeSearch(q);
      } catch (e) {
        setStatus(String(e.message || e));
        return;
      }
      lastSearchContext.formatted = center.formatted || "";
    }

    setStatus(`Berechne Distanzen … (${lastSearchContext.formatted || ""})`);

    const filtered = partners
      .filter((p) => typeof p.lat === "number" && typeof p.lng === "number")
      // Filter bleibt: Checkbox = nur bestätigte anzeigen
      .filter((p) => !needHufschuh || !!p.services?.hufschuh)
      .filter((p) => !needKlebe || !!p.services?.klebebeschlag)
      .map((p) => ({
        ...p,
        distance_km: haversineKm(center.lat, center.lng, p.lat, p.lng),
      }))
      .filter((p) => p.distance_km <= radiusKm)
      .sort((a, b) => a.distance_km - b.distance_km);

    window.__GS_LAST_FILTERED__ = filtered;

    clearList();
    cluster.clearLayers();

    const rendered = filtered.slice(0, 200);
    window.__GS_LAST_RENDERED__ = rendered;

    rendered.forEach((p) => {
      const marker = L.marker([p.lat, p.lng], { icon: partnerIcon }).bindPopup(buildPopup(p));
      cluster.addLayer(marker);

      addListItem(p, () => {
        if (window.__GS_PM_SET_VIEW__) window.__GS_PM_SET_VIEW__("map");
        map.setView([p.lat, p.lng], 11);
        marker.openPopup();
      });
    });

    if (filtered.length) {
      const bounds = L.latLngBounds(rendered.map((p) => [p.lat, p.lng]));
      map.fitBounds(bounds.pad(0.2));
      setStatus(`${filtered.length} Partner gefunden (Radius ${radiusKm} km).`);
    } else {
      map.setView([center.lat, center.lng], 10);
      setStatus(`Keine Partner im Radius ${radiusKm} km gefunden.`);
    }
  }

  function askForCurrentLocationOnce() {
    if (hasAskedForGeo) return;
    hasAskedForGeo = true;

    const ok = window.confirm("Möchtest du deinen aktuellen Standort für die Suche verwenden?");
    if (!ok) return;

    if (!navigator.geolocation) {
      setGeoHint("Dein Browser unterstützt keine Standortabfrage.");
      return;
    }

    setGeoHint("Ermittle aktuellen Standort …");
    setStatus("");

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        geoCenterOverride = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          formatted: "Aktueller Standort",
        };
        geoActive = true;

        setGeoHint("Aktueller Standort aktiv.");

        if (!geoAutoSearchEnabled || geoAutoSearchInFlight) return;

        geoAutoSearchInFlight = true;
        try {
          await runSearch();
        } finally {
          geoAutoSearchInFlight = false;
        }
      },
      () => {
        setGeoHint("Standort konnte nicht ermittelt werden.");
      },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }
    );
  }


  // Verhalten beim Fokus: einmalig fragen
  if (queryEl) {
    queryEl.addEventListener("focus", askForCurrentLocationOnce, { passive: true });
    queryEl.addEventListener("click", askForCurrentLocationOnce, { passive: true });
    queryEl.addEventListener("input", clearGeoOnManualInput, { passive: true });
  }

  // Geo-Button: expliziter Click
  if (geoBtn) {
    geoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      hasAskedForGeo = false;
      askForCurrentLocationOnce();
    });
  }

  if (searchBtn) searchBtn.addEventListener("click", runSearch);
  if (queryEl) queryEl.addEventListener("keydown", (e) => { if (e.key === "Enter") runSearch(); });
})();